import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type { AssetDetailResponse } from '@/entities/asset-search/domain/types';
import type {
  CreateRunParams,
  CreateRunResponse,
  GetRunsParams,
  RunListResponse,
  RunMetricsResponse,
} from '@/entities/run/domain/runManagementTypes';

const RUN_BASE_URL = '/runs';

export const runManagementApi = {
  getList: async (params?: GetRunsParams): Promise<RunListResponse> => {
    const response = await cycloneApiClient.get<RunListResponse>(RUN_BASE_URL, { params });
    return response.data;
  },

  create: async (params: CreateRunParams): Promise<CreateRunResponse> => {
    const response = await cycloneApiClient.post<CreateRunResponse>(RUN_BASE_URL, params);
    return response.data;
  },

  /** `source_run_id`: MLflow run UUID (`runs.source_run_id`) */
  getMetrics: async (sourceRunId: string): Promise<RunMetricsResponse> => {
    const response = await cycloneApiClient.get<RunMetricsResponse>(
      `${RUN_BASE_URL}/${encodeURIComponent(sourceRunId)}/metrics`,
      { skipGlobalErrorNotification: true }
    );
    return response.data;
  },

  /**
   * Run sync - 메트릭과 아티팩트 배치 적재 완료 후 동기화
   * POST /api/v1/runs/{run_id}/sync
   */
  sync: async (runId: number): Promise<AssetDetailResponse> => {
    const response = await cycloneApiClient.post<AssetDetailResponse>(`${RUN_BASE_URL}/${runId}/sync`);
    return response.data;
  },
};
